import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './softwareinfo.component.html',
    standalone: false
})
export class SoftwareInfoPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public softWareInfos: any;
  public inspection: Inspection;
  public applicationType = 0;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.applicationType = inspection.applicationType;
    this.initData();
    this.softWareInfos = this.plugin.config.SoftWareInfos;
    this.cdRef.detectChanges();
  }

  initData() {}

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'softwareinfo',
      'edit'
    ];
  }
}

PluginComponent.plugins['softwareinfo'] = SoftwareInfoPluginComponent;
